// Generated by Melange

import * as Buhta_kassaapis__Buhta_kassa_v1_types from "./buhta_kassa_v1_types.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const Buhta = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_receipt_data.ml",
      182,
      6
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ReceiptData"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ReceiptItemData"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ReceiptPaymentData"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ReceiptTaxData"
                    ]
                  ]
                },
                "V1alpha1"
              ]]
          },
          "Kassa"
        ]]
    });

const Kassa = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_receipt_data.ml",
      325,
      8
    ], {
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ReceiptData"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ReceiptItemData"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ReceiptPaymentData"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ReceiptTaxData"
              ]
            ]
          },
          "V1alpha1"
        ]]
    });

const V1alpha1 = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_receipt_data.ml",
      466,
      10
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ReceiptData"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ReceiptItemData"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ReceiptPaymentData"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ReceiptTaxData"
        ]
      ]
    });

const ReceiptData = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_receipt_data.ml",
      504,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ReceiptItemData = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_receipt_data.ml",
      594,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ReceiptPaymentData = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_receipt_data.ml",
      677,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ReceiptTaxData = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_receipt_data.ml",
      742,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.kassa.v1alpha1.ReceiptData";
}

function make(operation_typeOpt, domain_type, itemsOpt, paymentsOpt, taxesOpt, taken_amount, change_amount, receipt_num, param) {
  const operation_type = operation_typeOpt !== undefined ? operation_typeOpt : Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType.from_int_exn, 0);
  const items = itemsOpt !== undefined ? itemsOpt : /* [] */0;
  const payments = paymentsOpt !== undefined ? paymentsOpt : /* [] */0;
  const taxes = taxesOpt !== undefined ? taxesOpt : /* [] */0;
  return {
          operation_type: operation_type,
          domain_type: domain_type,
          items: items,
          payments: payments,
          taxes: taxes,
          taken_amount: taken_amount,
          change_amount: change_amount,
          receipt_num: receipt_num
        };
}

const merge_operation_type = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "operation_type",
            "operationType"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType),
          Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType.from_int_exn, 0)
        ]));

const merge_domain_type = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "domain_type",
            "domainType"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.DomainType)
        ]));

const merge_items = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            3,
            "items",
            "items"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: ReceiptItemData.name,
                make: ReceiptItemData.make,
                from_proto: ReceiptItemData.from_proto,
                from_proto_exn: ReceiptItemData.from_proto_exn,
                to_proto: ReceiptItemData.to_proto,
                to_proto$p: ReceiptItemData.to_proto$p,
                merge: ReceiptItemData.merge,
                to_json: ReceiptItemData.to_json,
                from_json_exn: ReceiptItemData.from_json_exn,
                from_json: ReceiptItemData.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

const merge_payments = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            4,
            "payments",
            "payments"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: ReceiptPaymentData.name,
                make: ReceiptPaymentData.make,
                from_proto: ReceiptPaymentData.from_proto,
                from_proto_exn: ReceiptPaymentData.from_proto_exn,
                to_proto: ReceiptPaymentData.to_proto,
                to_proto$p: ReceiptPaymentData.to_proto$p,
                merge: ReceiptPaymentData.merge,
                to_json: ReceiptPaymentData.to_json,
                from_json_exn: ReceiptPaymentData.from_json_exn,
                from_json: ReceiptPaymentData.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

const merge_taxes = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            5,
            "taxes",
            "taxes"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: ReceiptTaxData.name,
                make: ReceiptTaxData.make,
                from_proto: ReceiptTaxData.from_proto,
                from_proto_exn: ReceiptTaxData.from_proto_exn,
                to_proto: ReceiptTaxData.to_proto,
                to_proto$p: ReceiptTaxData.to_proto$p,
                merge: ReceiptTaxData.merge,
                to_json: ReceiptTaxData.to_json,
                from_json_exn: ReceiptTaxData.from_json_exn,
                from_json: ReceiptTaxData.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

const merge_taken_amount = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            6,
            "taken_amount",
            "takenAmount"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_change_amount = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            7,
            "change_amount",
            "changeAmount"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_receipt_num = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            8,
            "receipt_num",
            "receiptNum"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

function merge(t1, t2) {
  return {
          operation_type: Curry._2(merge_operation_type, t1.operation_type, t2.operation_type),
          domain_type: Curry._2(merge_domain_type, t1.domain_type, t2.domain_type),
          items: Curry._2(merge_items, t1.items, t2.items),
          payments: Curry._2(merge_payments, t1.payments, t2.payments),
          taxes: Curry._2(merge_taxes, t1.taxes, t2.taxes),
          taken_amount: Curry._2(merge_taken_amount, t1.taken_amount, t2.taken_amount),
          change_amount: Curry._2(merge_change_amount, t1.change_amount, t2.change_amount),
          receipt_num: Curry._2(merge_receipt_num, t1.receipt_num, t2.receipt_num)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "operation_type",
                    "operationType"
                  ],
                  Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType),
                  Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.OperationType.from_int_exn, 0)
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "domain_type",
                        "domainType"
                      ],
                      Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.DomainType)
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                          [
                            3,
                            "items",
                            "items"
                          ],
                          Ocaml_protoc_plugin__Spec.message({
                                name: ReceiptItemData.name,
                                make: ReceiptItemData.make,
                                from_proto: ReceiptItemData.from_proto,
                                from_proto_exn: ReceiptItemData.from_proto_exn,
                                to_proto: ReceiptItemData.to_proto,
                                to_proto$p: ReceiptItemData.to_proto$p,
                                merge: ReceiptItemData.merge,
                                to_json: ReceiptItemData.to_json,
                                from_json_exn: ReceiptItemData.from_json_exn,
                                from_json: ReceiptItemData.from_json
                              }),
                          Ocaml_protoc_plugin__Spec.not_packed
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                              [
                                4,
                                "payments",
                                "payments"
                              ],
                              Ocaml_protoc_plugin__Spec.message({
                                    name: ReceiptPaymentData.name,
                                    make: ReceiptPaymentData.make,
                                    from_proto: ReceiptPaymentData.from_proto,
                                    from_proto_exn: ReceiptPaymentData.from_proto_exn,
                                    to_proto: ReceiptPaymentData.to_proto,
                                    to_proto$p: ReceiptPaymentData.to_proto$p,
                                    merge: ReceiptPaymentData.merge,
                                    to_json: ReceiptPaymentData.to_json,
                                    from_json_exn: ReceiptPaymentData.from_json_exn,
                                    from_json: ReceiptPaymentData.from_json
                                  }),
                              Ocaml_protoc_plugin__Spec.not_packed
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                                  [
                                    5,
                                    "taxes",
                                    "taxes"
                                  ],
                                  Ocaml_protoc_plugin__Spec.message({
                                        name: ReceiptTaxData.name,
                                        make: ReceiptTaxData.make,
                                        from_proto: ReceiptTaxData.from_proto,
                                        from_proto_exn: ReceiptTaxData.from_proto_exn,
                                        to_proto: ReceiptTaxData.to_proto,
                                        to_proto$p: ReceiptTaxData.to_proto$p,
                                        merge: ReceiptTaxData.merge,
                                        to_json: ReceiptTaxData.to_json,
                                        from_json_exn: ReceiptTaxData.from_json_exn,
                                        from_json: ReceiptTaxData.from_json
                                      }),
                                  Ocaml_protoc_plugin__Spec.not_packed
                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                      [
                                        6,
                                        "taken_amount",
                                        "takenAmount"
                                      ],
                                      Ocaml_protoc_plugin__Spec.string
                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                          [
                                            7,
                                            "change_amount",
                                            "changeAmount"
                                          ],
                                          Ocaml_protoc_plugin__Spec.string
                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                              [
                                                8,
                                                "receipt_num",
                                                "receiptNum"
                                              ],
                                              Ocaml_protoc_plugin__Spec.string
                                            ]), Ocaml_protoc_plugin__Spec.nil))))))));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry.app(serialize, [
        writer,
        param.operation_type,
        param.domain_type,
        param.items,
        param.payments,
        param.taxes,
        param.taken_amount,
        param.change_amount,
        param.receipt_num
      ]);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(operation_type, domain_type, items, payments, taxes, taken_amount, change_amount, receipt_num) {
  return {
          operation_type: operation_type,
          domain_type: domain_type,
          items: items,
          payments: payments,
          taxes: taxes,
          taken_amount: taken_amount,
          change_amount: change_amount,
          receipt_num: receipt_num
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ReceiptData", spec(undefined))(options);
  return function (param) {
    return Curry._8(serialize, param.operation_type, param.domain_type, param.items, param.payments, param.taxes, param.taken_amount, param.change_amount, param.receipt_num);
  };
}

function constructor$1(operation_type, domain_type, items, payments, taxes, taken_amount, change_amount, receipt_num) {
  return {
          operation_type: operation_type,
          domain_type: domain_type,
          items: items,
          payments: payments,
          taxes: taxes,
          taken_amount: taken_amount,
          change_amount: change_amount,
          receipt_num: receipt_num
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ReceiptData", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ReceiptData, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.kassa.v1alpha1.ReceiptItemData";
}

function make$1(item_typeOpt, nameOpt, item_priceOpt, qtyOpt, measure_unit_code, section_code, section_name, untaxedOpt, param) {
  const item_type = item_typeOpt !== undefined ? item_typeOpt : Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.ItemType.from_int_exn, 0);
  const name = nameOpt !== undefined ? nameOpt : "";
  const item_price = item_priceOpt !== undefined ? item_priceOpt : "";
  const qty = qtyOpt !== undefined ? qtyOpt : "";
  const untaxed = untaxedOpt !== undefined ? untaxedOpt : false;
  return {
          item_type: item_type,
          name: name,
          item_price: item_price,
          qty: qty,
          measure_unit_code: measure_unit_code,
          section_code: section_code,
          section_name: section_name,
          untaxed: untaxed
        };
}

const merge_item_type = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "item_type",
            "itemType"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.ItemType),
          Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.ItemType.from_int_exn, 0)
        ]));

const merge_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            5,
            "name",
            "name"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_item_price = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            6,
            "item_price",
            "itemPrice"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_qty = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            7,
            "qty",
            "qty"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_measure_unit_code = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            8,
            "measure_unit_code",
            "measureUnitCode"
          ],
          Ocaml_protoc_plugin__Spec.int32_int
        ]));

const merge_section_code = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            9,
            "section_code",
            "sectionCode"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_section_name = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            10,
            "section_name",
            "sectionName"
          ],
          Ocaml_protoc_plugin__Spec.string
        ]));

const merge_untaxed = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            11,
            "untaxed",
            "untaxed"
          ],
          Ocaml_protoc_plugin__Spec.bool,
          false
        ]));

function merge$1(t1, t2) {
  return {
          item_type: Curry._2(merge_item_type, t1.item_type, t2.item_type),
          name: Curry._2(merge_name, t1.name, t2.name),
          item_price: Curry._2(merge_item_price, t1.item_price, t2.item_price),
          qty: Curry._2(merge_qty, t1.qty, t2.qty),
          measure_unit_code: Curry._2(merge_measure_unit_code, t1.measure_unit_code, t2.measure_unit_code),
          section_code: Curry._2(merge_section_code, t1.section_code, t2.section_code),
          section_name: Curry._2(merge_section_name, t1.section_name, t2.section_name),
          untaxed: Curry._2(merge_untaxed, t1.untaxed, t2.untaxed)
        };
}

function spec$1(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "item_type",
                    "itemType"
                  ],
                  Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.ItemType),
                  Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.ItemType.from_int_exn, 0)
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        5,
                        "name",
                        "name"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            6,
                            "item_price",
                            "itemPrice"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                              [
                                7,
                                "qty",
                                "qty"
                              ],
                              Ocaml_protoc_plugin__Spec.string,
                              ""
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                  [
                                    8,
                                    "measure_unit_code",
                                    "measureUnitCode"
                                  ],
                                  Ocaml_protoc_plugin__Spec.int32_int
                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                      [
                                        9,
                                        "section_code",
                                        "sectionCode"
                                      ],
                                      Ocaml_protoc_plugin__Spec.string
                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                                          [
                                            10,
                                            "section_name",
                                            "sectionName"
                                          ],
                                          Ocaml_protoc_plugin__Spec.string
                                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                              [
                                                11,
                                                "untaxed",
                                                "untaxed"
                                              ],
                                              Ocaml_protoc_plugin__Spec.bool,
                                              false
                                            ]), Ocaml_protoc_plugin__Spec.nil))))))));
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry.app(serialize$1, [
        writer,
        param.item_type,
        param.name,
        param.item_price,
        param.qty,
        param.measure_unit_code,
        param.section_code,
        param.section_name,
        param.untaxed
      ]);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(item_type, name, item_price, qty, measure_unit_code, section_code, section_name, untaxed) {
  return {
          item_type: item_type,
          name: name,
          item_price: item_price,
          qty: qty,
          measure_unit_code: measure_unit_code,
          section_code: section_code,
          section_name: section_name,
          untaxed: untaxed
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ReceiptItemData", spec$1(undefined))(options);
  return function (param) {
    return Curry._8(serialize, param.item_type, param.name, param.item_price, param.qty, param.measure_unit_code, param.section_code, param.section_name, param.untaxed);
  };
}

function constructor$3(item_type, name, item_price, qty, measure_unit_code, section_code, section_name, untaxed) {
  return {
          item_type: item_type,
          name: name,
          item_price: item_price,
          qty: qty,
          measure_unit_code: measure_unit_code,
          section_code: section_code,
          section_name: section_name,
          untaxed: untaxed
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ReceiptItemData", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ReceiptItemData, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

function name$2(param) {
  return ".buhta.kassa.v1alpha1.ReceiptPaymentData";
}

function make$2(payment_typeOpt, amountOpt, param) {
  const payment_type = payment_typeOpt !== undefined ? payment_typeOpt : Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.PaymentType.from_int_exn, 0);
  const amount = amountOpt !== undefined ? amountOpt : "";
  return {
          payment_type: payment_type,
          amount: amount
        };
}

const merge_payment_type = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "payment_type",
            "paymentType"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.PaymentType),
          Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.PaymentType.from_int_exn, 0)
        ]));

const merge_amount = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "amount",
            "amount"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

function merge$2(t1, t2) {
  return {
          payment_type: Curry._2(merge_payment_type, t1.payment_type, t2.payment_type),
          amount: Curry._2(merge_amount, t1.amount, t2.amount)
        };
}

function spec$2(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "payment_type",
                    "paymentType"
                  ],
                  Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.PaymentType),
                  Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.PaymentType.from_int_exn, 0)
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "amount",
                        "amount"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
    });

function to_proto$p$2(writer, param) {
  Curry._3(serialize$2, writer, param.payment_type, param.amount);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(payment_type, amount) {
  return {
          payment_type: payment_type,
          amount: amount
        };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
    });

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$2, writer);
            });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ReceiptPaymentData", spec$2(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.payment_type, param.amount);
  };
}

function constructor$5(payment_type, amount) {
  return {
          payment_type: payment_type,
          amount: amount
        };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ReceiptPaymentData", spec$2(undefined), constructor$5);
    });

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$2, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ReceiptPaymentData, {
      make: make$2,
      to_proto: to_proto$2,
      from_proto: from_proto$2,
      to_json: to_json$2,
      from_json: from_json$2,
      name: name$2,
      merge: merge$2,
      to_proto$p: to_proto$p$2,
      from_proto_exn: from_proto_exn$2,
      from_json_exn: from_json_exn$2
    });

function name$3(param) {
  return ".buhta.kassa.v1alpha1.ReceiptTaxData";
}

function make$3(tax_typeOpt, inclusiveOpt, percentOpt, param) {
  const tax_type = tax_typeOpt !== undefined ? tax_typeOpt : Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.TaxType.from_int_exn, 0);
  const inclusive = inclusiveOpt !== undefined ? inclusiveOpt : false;
  const percent = percentOpt !== undefined ? percentOpt : "";
  return {
          tax_type: tax_type,
          inclusive: inclusive,
          percent: percent
        };
}

const merge_tax_type = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "tax_type",
            "taxType"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.TaxType),
          Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.TaxType.from_int_exn, 0)
        ]));

const merge_inclusive = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "inclusive",
            "inclusive"
          ],
          Ocaml_protoc_plugin__Spec.bool,
          false
        ]));

const merge_percent = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "percent",
            "percent"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

function merge$3(t1, t2) {
  return {
          tax_type: Curry._2(merge_tax_type, t1.tax_type, t2.tax_type),
          inclusive: Curry._2(merge_inclusive, t1.inclusive, t2.inclusive),
          percent: Curry._2(merge_percent, t1.percent, t2.percent)
        };
}

function spec$3(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "tax_type",
                    "taxType"
                  ],
                  Ocaml_protoc_plugin__Spec.$$enum(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.TaxType),
                  Curry._1(Buhta_kassaapis__Buhta_kassa_v1_types.Buhta.Kassa.V1.TaxType.from_int_exn, 0)
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "inclusive",
                        "inclusive"
                      ],
                      Ocaml_protoc_plugin__Spec.bool,
                      false
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "percent",
                            "percent"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
    });

function to_proto$p$3(writer, param) {
  Curry._4(serialize$3, writer, param.tax_type, param.inclusive, param.percent);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(tax_type, inclusive, percent) {
  return {
          tax_type: tax_type,
          inclusive: inclusive,
          percent: percent
        };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
    });

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$3, writer);
            });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ReceiptTaxData", spec$3(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param.tax_type, param.inclusive, param.percent);
  };
}

function constructor$7(tax_type, inclusive, percent) {
  return {
          tax_type: tax_type,
          inclusive: inclusive,
          percent: percent
        };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ReceiptTaxData", spec$3(undefined), constructor$7);
    });

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$3, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ReceiptTaxData, {
      make: make$3,
      to_proto: to_proto$3,
      from_proto: from_proto$3,
      to_json: to_json$3,
      from_json: from_json$3,
      name: name$3,
      merge: merge$3,
      to_proto$p: to_proto$p$3,
      from_proto_exn: from_proto_exn$3,
      from_json_exn: from_json_exn$3
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ReceiptData"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ReceiptItemData"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ReceiptPaymentData"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "ReceiptTaxData"
        ]
      ]
    }, V1alpha1, {
      ReceiptData: ReceiptData,
      ReceiptItemData: ReceiptItemData,
      ReceiptPaymentData: ReceiptPaymentData,
      ReceiptTaxData: ReceiptTaxData
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ReceiptData"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ReceiptItemData"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ReceiptPaymentData"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "ReceiptTaxData"
              ]
            ]
          },
          "V1alpha1"
        ]]
    }, Kassa, {
      V1alpha1: V1alpha1
    });

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          {
            TAG: /* Module */0,
            _0: [[
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ReceiptData"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ReceiptItemData"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ReceiptPaymentData"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "ReceiptTaxData"
                    ]
                  ]
                },
                "V1alpha1"
              ]]
          },
          "Kassa"
        ]]
    }, Buhta, {
      Kassa: Kassa
    });

export {
  Imported$pmodules ,
  Buhta ,
}
/* Buhta Not a pure module */
